<template>
  <div class="article-4">
    <div class="article__info">
      <h1 class="article__title">總統票投誰？年輕人內心話</h1>
      <h2 class="article__subtitle">在意參選人特質 更重視政策帶來希望</h2>
      <div class="article__reporter">聯合報 記者：周志豪、周佑政、蔡孟妤、蔡容喬、林伯驊／報導</div>
    </div>

    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-4-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <SvgSymbol class="article__figure-caption-icon" use="#figure-caption-icon"/>
        <span>年輕人重視政策對自己未來的影響；圖為台大校園一隅。記者陳柏亨／攝影</span>
      </figcaption>
    </figure>

    <p class="article__paragraph">選舉腳步逼近，政黨展開攻防，年輕人聚在一起，或多或少觸及到投票話題，這些人除了受到周遭政治氛圍影響，在投票意向上，會去檢驗參選人的人格特質、兩岸立場，不過，更在意國家領導人能帶給他們希望。</p>
    <p class="article__paragraph">午餐時間，北部某公司同事一起吃飯，電視正播放藍綠總統參選人的新聞，擔任法務的林先生說，「我很害怕韓國瑜當選。」</p>
    <p class="article__paragraph">今年23歲的行政秘書劉小姐問，「為什麼？」林先生說，「韓國瑜無論個性、能力、團隊都有問題，若讓這樣的人當選，不敢想像國家會怎麼發展。」</p>
    <p class="article__paragraph">劉小姐說，「我也不喜歡韓國瑜」，才當選高雄市長、又選總統，「很貪心，不是很OK。」她話鋒一轉，「只是看大家都在黑韓，我就是不想一樣，決定要投韓國瑜。」</p>
    <p class="article__paragraph">在公司擔任服務人員、30歲的江小姐，原本低頭吃飯，也忍不住插話說，「蔡英文、韓國瑜，我都不喜歡」，韓國瑜選市長不到半年就選總統，沒有誠信，蔡英文推同婚立法，邦交國斷交，執政三年多，經濟每況愈下，看不到未來，「這次總統大選不會去投票。」</p>

    <h3 class="article__paragraph-title">年輕人投票關鍵 ─ 政策可執行度</h3>
    <p class="article__paragraph">33歲的阿慶，老家在桃園，目前在台北從事電視劇後製，因為是軍人子弟，每次選舉都跟著父母親投國民黨，「我們這種外省家庭就是不喜歡民進黨。」</p>
    <p class="article__paragraph">直到太陽花學運，阿慶開始關心政治，他在臉書幾個新聞媒體粉絲團「按讚」，偶爾會參與留言串討論，與網友「筆戰」。</p>
    <p class="article__paragraph">談到明年選舉，阿慶說，「我可能不會去投票」，因為藍綠都很爛，「黃國昌或柯文哲出來選總統，我一定投，因為他們藍綠都敢打。」沉默幾秒後，阿慶突然主動提起說，「韓國瑜剛出來時，我完全沒有感覺，但他說要蓋愛情摩天輪、迪士尼，我就想這也太唬爛了吧！」</p>
    <p class="article__paragraph">大學畢業後在旅行社工作近10年的張碩真，不熱衷政治，但每次都有去投票，她看人、不看政黨，原本郭台銘、柯文哲出來，她會考慮，現在可能投給蔡英文，「不會選韓國瑜，都在開空頭支票，什麼太平島挖石油，連我都知道不可能啊。」</p>

    <figure class="article__figure article__figure-in-article">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-4-1.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <SvgSymbol class="article__figure-caption-icon" use="#figure-caption-icon"/>
        <span>韓國瑜展現自製的愛情摩天輪相框。記者劉學聖／攝影</span>
      </figcaption>
    </figure>

    <h3 class="article__paragraph-title">年輕人投票關鍵 ─ 政策令人有感</h3>
    <p class="article__paragraph">將場景拉到高雄，27歲的吳季容是零售員，聊到選舉，她邊工作、邊答話說，「我支持韓國瑜，看好韓國瑜能出線，因為他很認真做事。」</p>
    <p class="article__paragraph">吳季容說，她家住苓雅區永泰路一帶，過去颱風天下大雨，「半夜要出來牽車搶救耶！」今年完全沒有，清淤治水展現成果，市民安心許多。</p>
    <p class="article__paragraph">但吳季容憂心，這次選舉「抹黑很嚴重，無中生有的事、莫須有的事很多」，對手拚命打韓、黑韓，鋪天蓋地的攻擊。</p>
    <p class="article__paragraph">26歲、同樣是上班族的吳子俊說，他支持國民黨，因為民進黨做事「鴨霸」，為反對而反對，在高雄完全執政時，態度明顯一黨獨大，「這回總統票我會投韓國瑜。」</p>
    <p class="article__paragraph">「只是落跑市長罵名滿傷的！」吳子俊說，綠營緊咬韓國瑜背棄高雄，確實有殺傷力，他身旁不少朋友對韓國瑜「落跑」反彈很大，但韓國瑜承諾照顧高雄，如果當選總統，對高雄建設、發展將是利多。</p>

    <h3 class="article__paragraph-title">年輕人投票關鍵 ─ 兩岸局勢發展</h3>
    <p class="article__paragraph">換個話題，和朋友聊到香港反送中，吳子俊說，香港政治型態與台灣不能相提並論，港人「反送中」是對「一國兩制」有疑慮，與具有主權身分的中華民國情況不同。</p>
    <p class="article__paragraph">吳子俊說，民進黨操作反送中議題，製造恐慌，讓年輕人焦慮，讓大家害怕台灣變成「香港第二」，說穿了，「為了選贏，不擇手段」。吳季容也說，民進黨拋出「今日香港、明日台灣」，讓年輕世代的焦慮感、亡國感上升，綠營意圖操作選舉，選民自有判斷。</p>
    <p class="article__paragraph">「反送中運動等議題，會影響你投票前的思考嗎？」就讀高雄大學政治法律系的林文洋堅定回答，「會」。他認為，藍營政策論述能力弱，反送中議題也沒處理好。</p>
    <p class="article__paragraph">身為首投族的林文洋，家住台南，父母是勞工、較挺民進黨，受原生家庭影響，政黨傾向偏綠，總統票會投給蔡英文。他說，小英雖然面臨私菸案、論文風波，但比起韓國瑜多次失言，不算失分太多。</p>
    <p class="article__paragraph">甫成為職場新鮮人的25歲高雄青年謝紹君，擔任壽險業務員，他說，去年市長票投給韓國瑜，期待高雄改變，但是「韓國瑜的言行當國家領導似乎不太適格」，蔡英文也有難以認同的缺點，總統票投給誰，尚難選擇。</p>

    <figure class="article__figure article__figure-in-article">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-4-2.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <SvgSymbol class="article__figure-caption-icon" use="#figure-caption-icon"/>
        <span>香港反送中大遊行活動。圖／本報資料照</span>
      </figcaption>
    </figure>

    <h3 class="article__paragraph-title">年輕人投票關鍵 ─ 政見牛肉辯論</h3>
    <p class="article__paragraph">由於「辣台妹」、「芒果乾」是綠營用來搶攻年輕選票，謝紹君說，「反送中」不會影響他投票的判斷，他希望國家領導人要具備前瞻視野、立定明確目標，才能帶領國家走上對的路。</p>
    <p class="article__paragraph">林文洋說，年輕人期待參選人提出創業基金、單身補貼等更多有感政策。</p>
    <p class="article__paragraph">「台灣年輕人很需要希望感！」吳子俊說，社會各角落很多需要幫助的人，年輕人想創業卻不敢，缺乏資源，希望參選人在青年政策、老年照顧、社會福利上，提出政見牛肉，回歸政策辯論，少一點政治口水。</p>

  </div>
</template>

<script>
export default {
  name: 'Article4'
}
</script>

<style lang="scss">
.article-4 {}
</style>
